<script lang="ts" setup>

</script>

<template>
  <div class="rounded-md dark:bg-gray-600 bg-gray-200 animate-pulse" />
</template>
